module.exports = __webpack_public_path__ + "img/ad_1.5e4e8f10.png";